import { IconLoader } from '@ui/src';
import { SheetTypes } from './types';
import Category from '../partial/reports/category';
import TotalSum from '../partial/reports/total-sum';
import ReportHeader from '../partial/reports/header';
import formatReportBalance from '../../hoc/helpers/format-report-balance';

import ROUTES from '../../routes';

import cn from './balance.module.css';

const Sheet = ({
  items,
  itemsVisible,
  totalAssets,
  totalLiabilities,
  checksum,
  search,
  isLoading,
}: SheetTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <div className={cn.balanceSheetList}>
        {items?.map((item) => (
          <Category
            fromPath={ROUTES.REPORTS_BALANCE_SHEET}
            itemsVisible={itemsVisible}
            category={item}
            key={item.id}
            withRoute
            search={search}
            type="balance"
          />
        ))}
        <TotalSum
          title="Total Assets"
          total={
            totalAssets || {
              debitIn: 0,
              debitOut: 0,
              debitTo: 0,
              creditIn: 0,
              creditOut: 0,
              creditTo: 0,
            }
          }
        />
        <TotalSum
          title="Total Liabilities"
          total={
            totalLiabilities || {
              debitIn: 0,
              debitOut: 0,
              debitTo: 0,
              creditIn: 0,
              creditOut: 0,
              creditTo: 0,
            }
          }
        />
      </div>
    );
  }

  return (
    <div className={cn.balanceSheetContent}>
      <ReportHeader />
      {content}
      <div
        className={`${cn.checksum} ${
          checksum && checksum !== 0 ? cn.checksumRed : ''
        }`}
      >
        <div>Checksum</div>
        <div>{isLoading ? '' : formatReportBalance(checksum || 0)}</div>
      </div>
    </div>
  );
};

export default Sheet;
